// ** Handle User Login
export const handleLogin = (user, entity, token) => {
  // ** Add to user, accessToken & refreshToken to localStorage
  localStorage.setItem("user", user);
  localStorage.setItem("token", token);
  localStorage.setItem("entity", entity);
  localStorage.setItem("selectedEntity", entity);
  let object = {
    type: "LOGIN",
    user: user,
    entity: entity,
    selectedEntity: entity,
    token: token,
  };
  return object;
};

export const handleOtp = () => async (isVerified) => {
    const entity = "user";
    const endPoint = `${process.env.REACT_APP_URL}/${entity}/record`;
    const user = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${endPoint}`, {
        method: "POST",
        body: JSON.stringify({
          userId: user.id,
        }),
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const result = await response.json();
        let object = {
          type: "OTP",
          isVerified: result.user.otp_verified,
        };
        return object;
      } else if (response.status === 401) {
        throw new Error("Token Expired");
      }
    } catch (e) {}
};
// ** Handle User Logout
export const handleLogout = () => {
  // ** Remove user, accessToken & refreshToken from localStorage
  let object = {
    type: "LOGOUT",
  };
  return object;
};

export const logout = () => async (dispatch) => {
  try {
    const entity = "user";
    const user = JSON.parse(localStorage.getItem("user"));
    const endPoint = `${process.env.REACT_APP_URL}/${entity}/logout?id=${user.id}`;
    const token = localStorage.getItem("token");
    await fetch(endPoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    });
    
    await dispatch(handleLogout());
    localStorage.clear();
    
    return true;
  } catch (e) {
    // Handle errors here
  }
};


export const roleUsers = () => async (dispatch) => {
  const entity = "user";
  const endPoint = `${process.env.REACT_APP_URL}/${entity}/role`;
  const token = localStorage.getItem("token");
  const selectedEntity = JSON.parse(localStorage.getItem("selectedEntity"));
  try {
    const response = await fetch(`${endPoint}`, {
      method: "POST",
      body: JSON.stringify({
        entity: selectedEntity._id,
      }),
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
    });
    if (response.status === 200) {
      const result = await response.json();
      await dispatch({
        type: "GET_ROLE_USERS",
        users: result.users,
      });
      return result.users;
    } else if (response.status === 401) {
      throw new Error("Token Expired");
    }
  } catch (e) {}
};
  export const loggedUser = () => async (dispatch) => {
    const entity = "user";
    const endPoint = `${process.env.REACT_APP_URL}/${entity}/record`;
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    try {
      const response = await fetch(`${endPoint}`, {
        method: "POST",
        body: JSON.stringify({
          userId: user.id,
        }),
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const result = await response.json();
        await dispatch({
          type: "GET_USER",
          user: result.user,
        });
        return result.users;
      } else if (response.status === 401) {
        throw new Error("Token Expired");
      }
    } catch (e) {}
};
